var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 12.6703V15.7437C3.33301 16.2095 3.5086 16.6562 3.82116 16.9856C4.13372 17.315 4.55765 17.5 4.99967 17.5H14.9997C15.4417 17.5 15.8656 17.315 16.1782 16.9856C16.4907 16.6562 16.6663 16.2095 16.6663 15.7437V12.6703M10.0005 2.5L10.0005 12.4521M10.0005 12.4521L6.19093 8.64943M10.0005 12.4521L13.81 8.64943",
    stroke: "#FF7148",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownload);
export default __webpack_public_path__ + "static/media/file-download.81ac29ee0ae4e0974df494dc53c30534.svg";
export { ForwardRef as ReactComponent };